const InformationPage = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 py-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">お知らせ</h1>
      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-600">お知らせページ（実装予定）</p>
      </div>
    </div>
  )
}

export default InformationPage